import { DataObjectOutlined } from '@mui/icons-material'
import { IconButton, ListItemIcon, ListItemText, MenuItem, Tooltip } from '@mui/material'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { Nullish } from '@omnea-app/packages/universal/utility-types/utilityTypes'

type Props = {
  entityTypeLabel?: string
  inDropdownWithIcon?: boolean
  getConfig?: () => unknown
  config?: Nullish<object>
}

export const CopyConfigButton: React.FC<Props> = ({ config, getConfig, entityTypeLabel = '', inDropdownWithIcon = false }) => {
  const { user } = useAuthenticatedUser()
  const title = `Copy ${entityTypeLabel} Config`

  if (!user.isOmnean) return null
  if (!config && !getConfig) return null

  const handleClick = async () => {
    const resolved = getConfig ? getConfig() : config
    if (process.env.NODE_ENV === 'development') {
      // oxlint-disable-next-line no-console
      console.log(JSON.stringify(resolved, null, 2))
    }
    await navigator.clipboard.writeText(JSON.stringify(resolved, null, 2))
  }

  if (inDropdownWithIcon) {
    return (
      <MenuItem onClick={() => handleClick()}>
        <ListItemIcon>
          <DataObjectOutlined />
        </ListItemIcon>
        <ListItemText primary={title} />
      </MenuItem>
    )
  }
  return (
    <Tooltip title={title}>
      <IconButton onClick={() => handleClick()}>
        <DataObjectOutlined />
      </IconButton>
    </Tooltip>
  )
}
